import React from "react";
import { connect } from "react-redux";
import * as redux from "redux";
import * as Comp from "../../components";
import { AppState } from "../../store";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    isSSR: state.ssr.isSSR,
    url: state.router.location ? state.router.location.pathname : undefined,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
});

interface OwnProps {
    message?: string | JSX.Element;
    title?: string;
}

interface ConnectedState {
    isSSR: boolean;
    url?: string;
}

interface ConnectedDispatch {
}

interface OwnState {
}

class NotFoundComponent extends React.Component<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {
    public render() {
        const url = typeof window !== "undefined"
            ? window.location.href
            : this.props.url;

        return <Comp.Page.PublicPage additionalClasses="full" pageTitle={this.props.isSSR ? undefined : "Error: Not Found"}>
            <div id="content-primary">
                <h2>{this.props.title || "Sorry, the page you requested cannot be found:"}</h2>

                <p>{url}</p>

                <p>The page you requested may have been removed, had its name changed, or been deleted. We apologize for the inconvenience.</p>

                <h2>Please try one of the following:</h2>

                <ul>
                    <li>Check the web address you entered to make sure it's correct.</li>
                    <li>Access the page directly from the main navigation instead of using a bookmark. If the page has moved, reset your bookmark.</li>
                    <li><Comp.Bug.Report linkText="Contact us to report this error" /></li>
                </ul>
            </div>

            <div id="content-secondary">
            </div>
        </Comp.Page.PublicPage>;
    }
}

export const NotFound: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(NotFoundComponent);



// WEBPACK FOOTER //
// ./src/containers/page/NotFound.tsx